<template>
  <div class="footer">
    <div class="contact-us" id="about">
      <div class="title">
        <p class="zh">联系我们</p>
        <p class="en">CONTACT</p>
      </div>
      <div class="footer-main">
        <p class="left text-ellipsis">
          {{contactText}}
        </p>
        <div class="right">
          <div class="pic-box" v-if="contactPic.pc">
            <img :src="contactPic.pc.img">
            <p class="text-ellipsis">{{contactPic.pc.value}}</p>
          </div>
          <div class="pic-box" v-if="contactPic.h5">
            <img :src="contactPic.h5.img">
            <p class="text-ellipsis">{{contactPic.h5.value}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <p class="left">
        <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank" rel="noopener noreferrer">
          ICP证京B2-20180942
        </a>
        |
        <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank" rel="noopener noreferrer">
          京ICP备12026130号-2
        </a>
        |
        <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank" rel="noopener noreferrer">
          京网安备11010802017565
        </a>
        <br />
        "<a herf="javascrip;" class="huodongxing" style="cursor: pointer;">活动行</a>"提供技术支持
      </p>
      <p class="right">
        <img src="@/assets/imgs/web-meeting/logo.png" width="197px" />
        <a href="/">隐私政策</a>
        <a href="/">用户协议</a>
      </p>
    </div>
    <div class="backtop">
      <el-backtop :right="-80" :bottom="160"></el-backtop>
    </div>
    <!-- <el-dialog
      append-to-body
      :title="$t('message.PrivacyOverviewTitle')"
      center
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <p style="color: #626262" v-html="$i18n.locale == 'zh'?introduction:introductionEn">
        {{$t('message.PrivacyOverview')}}
      </p>
    </el-dialog> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      eid: this.$route.query.eid || '', //会议id
      // dialogVisible: false,
      contactText: '',
      contactPic: {}
    };
  },
  created() {
    this.$callApi(this.$apiList.aboutUs, { eid: this.eid }).then(res => {
      const data = res.data
      this.contactText = data.aboutContent
      this.contactPic = JSON.parse(data.aboutPicture)
    })
  }
};
</script>
<style lang="less">
  .backtop {
    position: fixed;
    bottom: 0;
    width: 1080px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 3;
    .el-backtop {
      height: 60px;
      width: 60px;
      position: absolute;
      border: 1px solid rgba(90, 102, 122);
      color: rgba(90, 102, 122);
      opacity: 0.6;
      .el-icon-caret-top:before {
        content: '\e6e1';
      }
    }
  }
</style>
<style lang="less" scoped>
  @import '@/style/variable.less';
  .footer {
    padding-top: 40px;
    min-width: 1080px;
    background-color: #00002d;

    .contact-us {
      width: 1080px;
      margin: 0 auto;

      .title {
        .zh {
          font-size: 24px;
          color: #ffffff;
          line-height: 44px;
        }
        .en {
          font-size: 16px;
          color: rgba(255, 255, 255, 0.8);
          line-height: 22px;
        }
      }

      .footer-main {
        width: 1080px;
        display: flex;

        .left {
          flex-grow: 1;
          display: inline-block;
          padding: 20px 0;
          white-space: pre-line;
          font-size: 18px;
          color: rgba(255, 255, 255, 0.8);
          line-height: 28px;
        }

        .right {
          display: inline-block;

          .pic-box {
            display: inline-block;

            &:first-child {
              margin-right: 80px;
            }

            img {
              width: 100px;
              height: 100px;
            }

            p {
              width: 100%;
              text-align: center;
              font-size: 14px;
              color: #ffffff;
              line-height: 24px;
            }
          }
        }
      }
    }

    .copyright {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 108px;
      width: 1080px;
      border-top: 1px solid rgba(255, 255, 255, 0.15);
      margin: 20px auto 0;

      .left {
        line-height: 24px;
        color: #b0afaf;

        a {
          color: #b0afaf;
        }

        .huodongxing {
          color: #1abc51;
        }
      }

      .right {
        img {
          display: inline-block;
        }
        a {
          display: inline-block;
          margin-left: 20px;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.8);
          line-height: 20px;
          text-decoration: underline;
        }
      }
    }
  }
</style>
